import PartCreateEditComponent from 'src/components/features/superAdmin/partCreateEditComponent';

const CreateEditPartPage = () => <PartCreateEditComponent />;

export default CreateEditPartPage;
